import React from 'react';
import {Typography} from '@mui/material';
import MempoolTxList from "../../components/MempoolTxList";
import useLatestMempoolTxs from "../../queries/useLatestMempoolTxs";


const LatestMempoolTransactionsContent = ({allowExpand = false}) => {
    const latestTxsQuery = useLatestMempoolTxs();
    if (latestTxsQuery.isLoading) {
        return <Typography variant="body1">Loading...</Typography>;
    }
    if (latestTxsQuery.isError) {
        return <Typography variant="body1">Request failed.</Typography>;
    }

    return <MempoolTxList data={latestTxsQuery.data.payload} allowExpand={allowExpand}/>;
};

export default LatestMempoolTransactionsContent;
